import { BlogUserService } from './../../../data/repository/blog-repository/blog-user.service';
import {
  Component,
  OnInit,
  Input,
  OnDestroy,
  HostListener,
  ViewChild,
  ElementRef,
} from '@angular/core';
import {
  BlogTagModel,
  BlogPostModel,
} from 'src/app/core/model/object/blog-model';
import { Subscription } from 'rxjs';
import { BlogShared } from '../../general/shared/blog-shared';
import { BlogService } from 'src/app/data/repository/blog-repository/blog.service';
import { LoadingShared } from '../../general/shared/loading-shared';
import { SnackBarService } from 'src/app/data/repository/utils-repository/snack-bar.service';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-blog-with-tag',
  templateUrl: './blog-with-tag.component.html',
  styleUrls: ['./blog-with-tag.component.scss'],
})
export class BlogWithTagComponent implements OnInit, OnDestroy {
  @ViewChild('scrollTopBlogWithTag') private myScrollContainer: ElementRef;

  @Input('id') id: number;

  tag: BlogTagModel;
  dataIsReady = false;
  showDetail = false;
  showBlogWithTag = false;
  selectedPost: BlogPostModel;
  posts: BlogPostModel[];
  tagTitle = '';
  postsCount = 0;
  postsPage = 0;
  detailId = 10;
  tagId = 10;
  postPerPage = 10;
  notFound = false;
  myUsername = '';

  midDivScrollTop = 0;
  lastScrollTop = 0;
  midDivHeight = 0;
  postsPosition = [];
  lastPostHeight = 0;
  loadImage = [];

  subscription1: Subscription;
  subscription2: Subscription;
  subscription3: Subscription;
  subscription4: Subscription;
  subscription5: Subscription;

  constructor(
    private blogShared: BlogShared,
    private blogService: BlogService,
    private loadingShared: LoadingShared,
    private snackBarService: SnackBarService,
    private blogUserService: BlogUserService,
    private route: ActivatedRoute
  ) {
    this.tag = this.blogShared.blogSelectedTag;
    if (this.tag === undefined) {
      this.blogService.goback();
    }
    if (!this.tag.title.startsWith('#')) {
      this.tagTitle = '#' + this.tag.title;
    } else {
      this.tagTitle = this.tag.title;
      this.tag.title = this.tag.title.slice(1, this.tag.title.length);
    }
    this.blogUserService.getBlogUser().then((res) => {
      this.myUsername = res.userName;
    });
    // console.log('tag2', this._sharedService.blogSelectedTag, this.tag)
    this.id = parseInt(this.route.snapshot.paramMap.get('tagId'));
  }

  ngOnInit() {
    this.loadingShared.showLoading();
    this.blogService
      .getBlogPostsListWithTag(0, this.postPerPage, this.tag.title)
      .then((res) => {
        if (res.isSuccess()) {
          this.posts = res.getData().getBlogList().posts;
          this.postsCount = res.getData().getBlogList().count;
          if (this.postsCount === 0) {
            this.notFound = true;
          }
          this.dataIsReady = true;
          setTimeout(() => {
            this.getPostsPosition(true);
          }, 10);
        } else {
          this.snackBarService.showSnackBar('خطا در برقراری ارتباط با سرور!');
          this.dataIsReady = false;
        }
        this.loadingShared.hideLoading();
      });
    this.subscription1 = this.blogShared.blogOpenDetailObs$.subscribe((res) => {
      if (res.id === this.id.toString()) {
        for (let i = 0; i < this.posts.length; i++) {
          if (this.posts[i].id === res.postId) {
            this.openDetail(i);
          }
        }
      }
    });
    this.subscription2 = this.blogShared.blogOpenDetailCommentsObs$.subscribe(
      (res) => {
        if (res.id === this.id.toString()) {
          for (let i = 0; i < this.posts.length; i++) {
            if (this.posts[i].id === res.postId) {
              this.openDetailComments(i);
            }
          }
        }
      }
    );
    this.subscription3 = this.blogShared.openBlogWithTagObs$.subscribe((id) => {
      if (id === this.id) {
        this.openBlogWithTag();
      }
    });
    this.subscription4 = this.blogShared.removePostObs$.subscribe((remove) => {
      if (remove && this.blogShared.selectedRemovingPostId !== '') {
        let index = -1;
        this.posts.forEach((post, i) => {
          if (post.id === this.blogShared.selectedRemovingPostId) {
            index = i;
          }
        });
        this.posts.splice(index, 1);
      }
    });
    this.subscription5 = this.blogShared.usernameChangeObs$.subscribe(
      (changed) => {
        if (changed) {
          this.myUsername = this.blogShared.newUsername;
        }
      }
    );
  }

  @HostListener('window:beforeunload')
  ngOnDestroy(): void {
    this.subscription1.unsubscribe();
    this.subscription2.unsubscribe();
    this.subscription3.unsubscribe();
    this.subscription4.unsubscribe();
    this.subscription5.unsubscribe();
  }

  scroll(scrollToTop: boolean, force: boolean) {
    this.lastScrollTop = force ? 0 : this.lastScrollTop;
    this.midDivScrollTop = scrollToTop
      ? 0
      : this.myScrollContainer.nativeElement.scrollTop;
    if (Math.floor(this.midDivScrollTop / 200) >= this.lastScrollTop) {
      this.postsPosition.forEach((postPosition, i) => {
        if (
          this.midDivHeight + this.midDivScrollTop >= postPosition &&
          !this.loadImage[i]
        ) {
          this.loadImage[i] = true;
        }
      });
      if (
        this.midDivHeight + this.midDivScrollTop >=
          this.postsPosition[this.postsPosition.length - 1] +
            this.lastPostHeight &&
        this.postsCount > (this.postsPage + 1) * this.postPerPage
      ) {
        this.showMorePosts();
      }
      this.lastScrollTop = Math.floor(this.midDivScrollTop / 200) + 1;
      // console.log(this.loadImage)
    }
  }

  getPostsPosition(scrollToTop: boolean) {
    if (scrollToTop) {
      this.midDivScrollTop = 0;
      this.lastScrollTop = 0;
      this.midDivHeight = 0;
      this.lastPostHeight = 0;
      this.postsPosition = [];
      this.loadImage = [];
    }
    const postsPosition = document.getElementsByClassName('appPostBlogWithTag');
    for (let i = 0; i < postsPosition.length; i++) {
      const p = postsPosition[i] as HTMLElement;
      this.postsPosition[i] = p.offsetTop;
      const positionInfo = p.getBoundingClientRect();
      this.lastPostHeight = positionInfo.height;
    }
    this.midDivHeight = this.myScrollContainer.nativeElement.offsetHeight;
    // console.log('postsposition', this.postsPosition, this.lastPostHeight)
    // console.log('height', this.midDivHeight)
    this.scroll(scrollToTop, true);
  }

  showMorePosts() {
    this.loadingShared.showLoading();
    this.postsPage++;
    this.blogService
      .getBlogPostsListWithTag(this.postsPage, this.postPerPage, this.tag.title)
      .then((res) => {
        if (res.isSuccess()) {
          this.posts = [...this.posts, ...res.getData().getBlogList().posts];
          this.postsCount = res.getData().getBlogList().count;
          setTimeout(() => {
            this.getPostsPosition(false);
          }, 10);
        } else {
          this.snackBarService.showSnackBar('خطا در برقراری ارتباط با سرور!');
        }
        this.loadingShared.hideLoading();
      });
  }

  openDetail(index: number) {
    this.blogShared.blogZIndex++;
    this.detailId = this.blogShared.blogZIndex;
    this.selectedPost = this.posts[index];
    // console.log('sssss', this.selectedPost)
    this.showDetail = true;
    setTimeout(() => {
      document.getElementById('botomsheet' + this.id).style.top = '0';
    }, 100);
  }

  openDetailComments(index: number) {
    this.blogShared.blogZIndex++;
    this.detailId = this.blogShared.blogZIndex;
    this.selectedPost = this.posts[index];
    this.showDetail = true;
    setTimeout(() => {
      document.getElementById('botomsheet' + this.id).style.top = '0';
      this.blogShared.blogScrollToComments();
    }, 100);
  }

  closeDetail() {
    this.blogShared.blogZIndex--;
    document.getElementById('botomsheet' + this.id).style.top = '100%';
    setTimeout(() => {
      this.showDetail = false;
    }, 300);
  }

  openBlogWithTag() {
    this.blogShared.blogZIndex++;
    this.tagId = this.blogShared.blogZIndex;
    this.showBlogWithTag = true;
    setTimeout(() => {
      document.getElementById('blogWithTag' + this.id).style.zIndex =
        this.blogShared.blogZIndex.toString();
      document.getElementById('blogWithTag' + this.id).style.right = '0';
    }, 100);
  }

  closeBlogWithTag() {
    this.blogService.goback();
  }
}
